
//
import {useRouter} from "vue-router";

const columnList: Array<column> = [
    {
        prop: "time",
        label: "开单时间",
        width: 100,
    },
    {
        prop: "meeter",
        label: "接车人",
        width: 100,
    },
    {
        prop: "partsName",
        label: "配件名称",
        width: 200,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 100,
    },
    {
        prop: "num",
        label: "数量",
        width: 100,
    },
    {
        prop: "carCode",
        label: "车牌",
        width: 100,
    },
    {
        prop: "serveType",
        label: "服务类型",
        width: 100,
    },
];

const offerColumn: Array<column> = [
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    },
];
const projectColumn: Array<column> = [
    {
        prop: "project_name",
        label: "维修项目报价",
        width: 80,
    },
    ...offerColumn,
];
const partsColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件报价",
        width: 80,
    },
    {
        prop: "supplier_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    }
];
const mountingsCostColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件成本",
        width: 80,
    },
    {
        prop: "collar_num",
        label: "领料",
        width: 80,
    },
    {
        prop: "retreat_num",
        label: "退料",
        width: 80,
    },
    {
        prop: "use_num",
        label: "用量",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "cost",
        label: "成本价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
];
const elseCostColumn: Array<column> = [
    {
        prop: "othercosts_name",
        label: "其他成本",
        width: 80,
    },
    {
        prop: "supplier_id_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "cpayment_text",
        label: "生成应付款",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "othercosts_costprice",
        label: "金额",
        width: 80,
    },
];
const settlementColumn: Array<column> = [
    {
        prop: "pay_name",
        label: "工单结算",
        width: 80,
    },
    {
        prop: "pay_type_name",
        label: "支付方式",
        width: 80,
    },
    {
        prop: "pay_price",
        label: "金额",
        width: 80,
    },
    {
        prop: "pay_ctime",
        label: "时间",
        width: 80,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";

import {Request} from "@/api/request"
import {getOrderCarOrderinfo, getWaitPurchaseList} from "@/api/http";
import { column } from "@/assets/types/common";

export default defineComponent({
    name: "waitPurchaseList",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["待采购列表"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            total = ref(0),
            Router = useRouter(),
            tableData = ref([] as Array<any>),
            formRef = ref(null),
            search = ref(''),
            roleList = ref({} as any),
            form_load = ref(false),
            loading = ref(true),
            headClass = inject("headClass"),
            
            //工单详情
            dialogFormVisible = ref(false),
            dialogTable = ref([] as Array<any>),
            orderDetail = ref({} as any),
            
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            addPurchasse = ((item:any)=>{
                _option('/purchase/readyUseParts', {type: 'existing',order_id:item.order_id,car_code:item.carCode});
            }),
            _option = (url: string , data: any) => {
                Router.push({
                    path: url,
                    query: data
                })
            },
            getSummariesDia = (param: any, type: number): Array<string> => {
                const {columns, data} = param;
                const sums: any = [];
                const propArr = [
                    "othercosts_costprice",
                    "price",
                    "output_value",
                    "pay_price",
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        switch (type) {
                            // 维修项目报价合计
                            case 1:
                                if (column.property == "price") {
                                    sums[index] = orderDetail.value.project_sum_quoted_price;
                                } else {
                                    sums[index] = orderDetail.value.project_sum_output_value;
                                }
                                break;
                            // 配件报价合计
                            case 2:
                                if (column.property == "output_value") {
                                    sums[index] = orderDetail.value.mountings_sum_output_value;
                                } else {
                                    sums[index] = orderDetail.value.mountings_sum_quoted_price;
                                }
                        
                                break;
                            // 配件成本合计
                            case 3:
                                sums[index] = orderDetail.value.mountings_cost_price;
                                break;
                            // 其他成本合计
                            case 4:
                                sums[index] = orderDetail.value.else_cost_price;
                                break;
                            // 工单结算合计
                            case 5:
                                sums[index] = orderDetail.value.settlement_pirce;
                                break;
                        }
                        sums[index] = `¥${sums[index]}`;
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            // 点击单据编号触发
            getOrderCarinfo = (item: any) => {
                if (item.order_id<=0){
                    return;
                }
                getOrderCarOrderinfo({order_id: item.order_id}).then((res: any) => {
                    if (res.status == 200) {
                        dialogFormVisible.value = true;
                        let info = res.content.list;
                        if (info) {
                            let arr = [[
                                '单据编号',
                                info.ordersn,
                                '状态',
                                info.orderstatustext,
                                '开单时间',
                                info.create_time_text,
                                '结算时间',
                                info.settlement_time_text,
                            ], [
                                '服务类型',
                                info.basicset_id_name,
                                '接车人',
                                info.meet_vehicle_id_name,
                                '报价金额',
                                info.offer_price,
                                '结算金额',
                                info.settlement_pirce,
                            ], [
                                '车牌号码',
                                info.car_code,
                                '品牌车型',
                                info.series_name,
                                '进厂里程',
                                info.mitplant,
                                '是否返修',
                                info.is_rework_text,
                            ], [
                                '送修人',
                                info.send_for_repair,
                                '手机号码',
                                info.send_for_repair_phone,
                                '会员号',
                                info.user_id,
                                '昵称',
                                info.user_nickname,
                            ], [
                                '保险公司',
                                info.cicompany_id_name,
                                '送修单位',
                                info.units_id_name,
                                '合作方',
                                info.partner_id_name,
                                '工单备注',
                                info.settlement_notes,
                            ]];
                            dialogTable.value = arr;
                            orderDetail.value = res.content.list;
                        }
                    }
                });
            },
            getTableData = (): void => {
                loading.value = true;
                let data = {
                    page:currentPage.value,
                    pagesize:pageSize.value,
                    search:search.value
                }
                getWaitPurchaseList(data).then((res: any) => {
                    let _list = res?.content?.list || [];
                    loading.value = false;
                    tableData.value = _list;
                    total.value = res?.content?.total;
                    total.value = res?.content?.total || 0;
                });
            },
            
            searchChange = (e:string) => {
                getTableData();
            };
        
        onMounted(() => {
            getTableData();
        });
        
        return {
            columnList,
            tableData,
            loading,
            search,
            headClass,
            screen,
            handleSizeChange,
            handleCurrentChange,
            formRef,
            form_load,
            searchChange,
            total,
            roleList,
            currentPage,
            pageSize,
            addPurchasse,
            _option,
    
            dialogFormVisible,
            getOrderCarinfo,
            dialogTable,
            orderDetail,
            getSummariesDia,
            projectColumn,
            partsColumn,
            mountingsCostColumn,
            elseCostColumn,
            settlementColumn
        };
    },
});
